import { useEffect, useState } from 'react';

/**
 * Returns `true` only after `flag` has been continuously `true` for `delayMs`.
 * Prevents skeleton flash on fast loads — closes boneyard's missing pre-delay gap
 * (boneyard has a fade-out `transition` but no pre-display delay).
 *
 * Use as the `loading` source: `<Skeleton loading={useSkel(useDelayedFlag(isLoading))} />`.
 * When `flag` goes false the result drops immediately.
 */
export function useDelayedFlag(flag: boolean, delayMs = 200): boolean {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!flag) {
      setShown(false);
      return;
    }
    const timer = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(timer);
  }, [flag, delayMs]);

  return shown;
}
